import { ForwardedRef, forwardRef, Fragment } from "react"
import { MENU_ITEM_ICON_DIVIDER } from "src/libs/basic-view/ExtendMenu"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export enum TABLE_THREAD_TYPE {
    LIGHT="thead-light",
    DARK="thead-dark",
    SECONDARY="bg-secondary text-white",
    DANGER="bg-danger text-white",
    SUCCESS="bg-success text-white",
    WARN="bg-warn text-dark",
} 
export interface ITableRow { 
    title:string
    width?: number|string
    isHidden?: boolean
    scope: string
    colSpan?: number
}
export interface ITableProps {
    rows: ITableRow[]
    threadType?: TABLE_THREAD_TYPE
    striped?: boolean
    data: ( JSX.Element | string | number | undefined )[]
    className?: string
    id?: string
    threadClassName?: string 
}
const Table = forwardRef((props: ITableProps, ref: ForwardedRef<HTMLTableElement>): JSX.Element => {
    return <div className='statistic-table-container'>
        <table 
            className={`table ${ props.striped ? "table-striped" : "" } table-hover1 ${ props.className || "" } w-100 mt-0`} 
            id={ props.id }
            ref={ ref } // layout-three-columns
        >
            <thead className={ props.threadType }>   
                <tr className={props.threadClassName}>
                    {
                        props.rows.map(( row: ITableRow, i: number ) => {
                            const rows = props.rows.map( r => {
                                return __(r.title) + MENU_ITEM_ICON_DIVIDER + 
                                    (r.isHidden ? "blank" : "small-tick") + 
                                    MENU_ITEM_ICON_DIVIDER + 
                                    "hiddenRow"  + MENU_ITEM_ICON_DIVIDER + 
                                    props.id + "." + r.scope 
                            }).join("||")
                            return row.isHidden
                                ?
                                <Fragment key={ row.scope } />
                                :
                                <th 
                                    scope={ row.scope } 
                                    key={ row.scope } 
                                    style={{ width: row.width }} 
                                    context-title={`${`Show/hide rows${MENU_ITEM_ICON_DIVIDER}layout-three-columns||${rows}`}`}
                                    
                                >
                                    {__( row.title )}
                                </th>
                        })
                    }
                </tr>
            </thead>
            <tbody>
                {
                    Array.isArray( props.rows) && !!props.rows.length
                        ?
                        Array( props.data.length / props.rows.length).fill(1).map((_, i: number) => {
                            return <tr>
                                {
                                    props.data
                                        .filter( (dt, ii) => ii >= i * props.rows.length && ii < ( i + 1 ) * props.rows.length )
                                        .filter( (td, iii) => !props.rows[iii].isHidden)
                                        .map((td, iii) => {
                                            return <td key={iii} colSpan={ props.rows[iii].colSpan }>
                                                { td }
                                            </td>
                                        })
                                }
                            </tr>
                        })
                        :
                        <></> 
                }
            </tbody>
        </table>
    </div>
})

export default Table